module.exports = __webpack_public_path__ + "static/media/right-arrow-disabled.6fd02b46.svg";